import StarRating from "vue-star-rating";
import { formatWholePrice } from "@/helpers";

export default {
    name: "BlogProduct",
    props: {
        info: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
           showDropdown: false,
           selectedProductPrice: null
        }
    },
    computed: {
      sortedList() {
        const list = [...this.info.product.data.productPrices.data];
        let sortedList = list.sort((a, b) => b.value - a.value);
        sortedList = sortedList.sort((a, b) => {
          if (a.isRefill && !b.isRefill) return 1;
          if (!a.isRefill && b.isRefill) return -1;

          return b.value - a.value;
        });
        return sortedList;
      },
    },
    components: {
        StarRating,
    },
    created() {
      this.$nextTick(() => {
        this.selectedProductPrice = this.sortedList[0];
      })
    },
    methods: {
        formatWholePrice,
        selectVolume(payload) {
            this.showDropdown = false;
            this.selectedProductPrice = payload;
        },
    }
}
